export var mockPageConfig = {
  __typename: "PageConfiguration",
  itunesAppUrl: "itms://itunes.apple.com/au/app/catchoftheday/id505027211?mt=8",
  footerItunesAppUrl: "https://catch.onelink.me/N79h/DownloadAppFooter",
  homeUspItunesAppUrl: "https://catch.onelink.me/N79h/152f671c",
  googlePlayUrl: "https://play.google.com/store/apps/details?id=au.com.catchoftheday.android",
  footerGooglePlayUrl: "https://catch.onelink.me/N79h/DownloadAppFooter",
  homeUspGooglePlayUrl: "https://catch.onelink.me/N79h/152f671c"
};